// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import DealerInvoiceList, {getDefaultState as getDealerInvoiceListDefaultState} from './dealer-invoice-list';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import Invoice, {getDefaultState as getInvoiceDefaultState} from '@deere/cps-it.warranty-model-factory/lib/invoice';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const DealerInvoices = t.struct({
    busyCounter: BusyCounter,
    dealerInvoices: DealerInvoiceList,
    facets: Facets,
    invoiceToComplete: Invoice,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, {
    name: 'DealerInvoices',
    strict: true
});

export const getDefaultState = () =>
    new DealerInvoices({
        busyCounter: getBusyCounterDefaultState(),
        dealerInvoices: getDealerInvoiceListDefaultState(),
        facets: getFacetsDefaultState(),
        invoiceToComplete: getInvoiceDefaultState(),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: ''
    });

export default DealerInvoices;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/state/index.js